import React from 'react';

const Linear_Algebra = () => {
    return (
        <div>Linear_Algebra Component</div>
    );
}

export default Linear_Algebra;
